<template>
  <message-template
    :direction="'incoming'"
    :time="time"
    :image="image">
    <div class="log-send-postback-template-block">
      <div class="field">
        <div class="control is-expanded">
          <button
            class="button is-focused"
            :class="{'is-rounded': isQuickReply}">
            <span class="button-text" @click="copyPayload(postbackButtonObj.payload)">{{postbackButtonObj.title}}</span>
          </button>
        </div>
      </div>
    </div>
  </message-template>
</template>
<script>
import MessageTemplate from './MessageTemplate.vue';

export default {
  name: 'sendPostbackTemplate',
  components: {
    'message-template': MessageTemplate,
  },
  props: {
    data: {
      type: Object,
    },
    prevData: {
      type: Object,
    },
    time: {
      type: Number,
      default: 0,
    },
    channel: {
      type: String,
      default: '',
    },
    uid: {
      type: String,
    },
    image: {
      type: String,
      default: '',
    },
  },
  computed: {
    postbackButtonObj() {
      if (this.prevData) {
        const selected = this.data.postback;
        let foundTitle = '';
        let foundPayload = '';
        if (this.prevData.data && this.prevData.data.items) {
          for (let i = 0; i < this.prevData.data.items.length; i += 1) {
            const item = this.prevData.data.items[i];
            if (item.payload === selected) {
              foundTitle = item.title;
              foundPayload = item.payload;
            }
          }
          if (foundTitle && foundPayload) {
            return {
              title: foundTitle,
              payload: foundPayload
            };
          }
        }
        return {
          title: this.data.postback,
          payload: this.data.postback
        };
      }
      return {
        title: this.data.postback,
        payload: this.data.postback
      };
    },
    postbackButton() {
      if (this.prevData) {
        const selected = this.data.postback;
        let foundTitle = '';
        if (this.prevData.data && this.prevData.data.items) {
          for (let i = 0; i < this.prevData.data.items.length; i += 1) {
            const item = this.prevData.data.items[i];
            if (item.payload === selected) {
              foundTitle = item.title;
            }
          }
          if (foundTitle) {
            return foundTitle;
          }
        }
        return this.data.postback;
      }
      return this.data.postback;
    },
    isQuickReply() {
      if (this.prevData) {
        return this.prevData.type === 'send_quick_reply';
      }
      return false;
    },
  },
  methods: {
    copyPayload(payload) {
      navigator.clipboard.writeText(payload);
    }
  }
};
</script>
<style lang="scss" scoped>
  .log-send-postback-template-block {
    max-width: 100%;
    display: inline-block;
    text-align: left;
    border-radius: 10px 0 10px 10px;
    .button {
      overflow: hidden;
      max-width: 100%;
      .button-text{
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>
